// features/health-insurance/health-insurance.slice.ts
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { submitHealthInsuranceFormApi, HealthInsuranceFormPayload } from './health-insurance.service';

export const submitHealthInsuranceForm = createAsyncThunk(
  'healthInsurance/submitHealthInsuranceForm',
  async (payload: HealthInsuranceFormPayload) => {
    const data = await submitHealthInsuranceFormApi(payload);
    return data;
  }
);

type Awaited<T> = T extends Promise<infer U> ? U : T;

type HealthInsuranceState = {
  message: string | null;
  healthInsuranceData: Awaited<ReturnType<typeof submitHealthInsuranceFormApi>> | null;
  loading: boolean;
  error: string | null;
};

const initialState: HealthInsuranceState = {
  message: null,
  healthInsuranceData: null,
  loading: false,
  error: null,
};

const healthInsuranceSlice = createSlice({
  name: 'healthInsurance',
  initialState,
  reducers: {
    clearHealthInsuranceData: (state) => {
      state.healthInsuranceData = null;
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(submitHealthInsuranceForm.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitHealthInsuranceForm.fulfilled, (state, action) => {
        state.loading = false;
        state.healthInsuranceData = action.payload;
        state.message = 'Health insurance form submitted successfully!';
      })
      .addCase(submitHealthInsuranceForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to submit health insurance form';
      });
  },
});

export const { clearHealthInsuranceData } = healthInsuranceSlice.actions;
export default healthInsuranceSlice.reducer;
